import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Cookie, ChevronDown, ChevronUp } from "lucide-react";

const STORAGE_KEY = "vdi_cookie_consent";

export const CookieBanner = () => {
    const [open, setOpen] = useState(false);
    const [customize, setCustomize] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [marketing, setMarketing] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (!stored) setOpen(true);
    }, []);

    const persist = async (choice) => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...choice, at: new Date().toISOString() }));
        try {
            await api.post("/consent/cookies", choice);
        } catch {}
        setOpen(false);
    };

    if (!open) return null;

    // Wrapper has pointer-events: none so banner doesn't block clicks on UI behind empty areas.
    // Inner content re-enables pointer events.
    return (
        <div className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4 fade-up pointer-events-none" data-testid="cookie-banner">
            <div className="max-w-2xl mx-auto pointer-events-auto bg-paper border border-border-line soft-shadow-lg rounded-2xl overflow-hidden">
                {collapsed ? (
                    <button onClick={() => setCollapsed(false)} className="w-full px-4 py-2 flex items-center justify-between text-sm" data-testid="cookie-expand">
                        <span className="flex items-center gap-2 text-muted">
                            <Cookie size={14} className="text-bordeaux" /> Gestisci cookie
                        </span>
                        <ChevronUp size={14} className="text-soft" />
                    </button>
                ) : (
                    <div className="p-4 sm:p-5">
                        <div className="flex items-start gap-3">
                            <div className="w-8 h-8 rounded-full bg-surface flex items-center justify-center shrink-0">
                                <Cookie size={16} className="text-bordeaux" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-start justify-between gap-2">
                                    <h3 className="font-heading text-lg text-ink">Rispettiamo la tua privacy</h3>
                                    <button onClick={() => setCollapsed(true)} className="text-soft hover:text-ink p-1" data-testid="cookie-collapse" title="Riduci">
                                        <ChevronDown size={14} />
                                    </button>
                                </div>
                                <p className="text-xs text-muted mt-1 leading-relaxed">
                                    Usiamo cookie necessari e — col tuo consenso — analitici e di marketing.{" "}
                                    <Link to="/cookie-policy" className="text-bordeaux hover:underline">Cookie Policy</Link>.
                                </p>
                                {customize && (
                                    <div className="mt-3 space-y-2 text-sm bg-surface rounded-xl p-3">
                                        <label className="flex items-center justify-between gap-3 opacity-60">
                                            <div>
                                                <div className="font-medium text-ink text-xs">Necessari</div>
                                                <div className="text-[10px] text-muted">Sempre attivi</div>
                                            </div>
                                            <input type="checkbox" checked disabled className="w-4 h-4 accent-bordeaux" />
                                        </label>
                                        <label className="flex items-center justify-between gap-3">
                                            <div>
                                                <div className="font-medium text-ink text-xs">Analitici</div>
                                            </div>
                                            <input data-testid="cookie-analytics" type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="w-4 h-4 accent-bordeaux" />
                                        </label>
                                        <label className="flex items-center justify-between gap-3">
                                            <div>
                                                <div className="font-medium text-ink text-xs">Marketing</div>
                                            </div>
                                            <input data-testid="cookie-marketing" type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} className="w-4 h-4 accent-bordeaux" />
                                        </label>
                                    </div>
                                )}
                                <div className="flex flex-wrap gap-2 mt-3">
                                    <button data-testid="cookie-accept-all" onClick={() => persist({ analytics: true, marketing: true })} className="btn-primary text-xs px-4 py-1.5">Accetta tutti</button>
                                    <button data-testid="cookie-reject" onClick={() => persist({ analytics: false, marketing: false })} className="btn-outline text-xs px-4 py-1.5">Rifiuta</button>
                                    {!customize ? (
                                        <button data-testid="cookie-customize" onClick={() => setCustomize(true)} className="btn-ghost text-xs px-4 py-1.5">Personalizza</button>
                                    ) : (
                                        <button data-testid="cookie-save" onClick={() => persist({ analytics, marketing })} className="btn-ghost text-xs px-4 py-1.5">Salva</button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
